<template>
<div class="icon-sprite">
  <div class="custom-container">
    <div class="icon-sprite__title">ICONS</div>
    <div class="icon-sprite__list">
      <div class="icon-sprite__item" v-for="icon in icons" :key="icon.id">
        <div class="icon-sprite__icon">
          <svg-icon :type="icon.name"></svg-icon>
        </div>
        <div class="icon-sprite__name">{{ icon.name }}</div>
      </div>
    </div>

    <div class="height-500"></div>
  </div>
</div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import ArrowDown from '@/assets/icons/icon-arrow-down.svg'
import ArrowUp from '@/assets/icons/icon-arrow-up.svg'
import ArrowLongRight from '@/assets/icons/icon-arrow-long-right.svg'
import ArrowLongLeft from '@/assets/icons/icon-arrow-long-left.svg'
import Plus from '@/assets/icons/icon-plus.svg'
import Search from '@/assets/icons/icon-search.svg'
import User from '@/assets/icons/icon-user.svg'
import Bed from '@/assets/icons/icon-bed.svg'
import Food from '@/assets/icons/icon-food.svg'
import Phone from '@/assets/icons/icon-phone.svg'
import Wifi from '@/assets/icons/icon-wifi.svg'
import ArrowRight from '@/assets/icons/icon-arrow-right.svg'
import ArrowLeft from '@/assets/icons/icon-arrow-left.svg'
import Mail from '@/assets/icons/icon-mail.svg'
import Headphone from '@/assets/icons/icon-headphone.svg'
import Facebook from '@/assets/icons/icon-facebook.svg'
import Twitter from '@/assets/icons/icon-twitter.svg'
import Instagram from '@/assets/icons/icon-instagram.svg'
import Linkedin from '@/assets/icons/icon-linkedin.svg'
import Whatsapp from '@/assets/icons/icon-whatsapp.svg'
import Heart from '@/assets/icons/icon-heart.svg'
import Print from '@/assets/icons/icon-print.svg'
import Export from '@/assets/icons/icon-export.svg'
/*
import RoomTel from '@/assets/icons/icon-roomtel.svg'
import Library from '@/assets/icons/icon-library.svg'
import Fridge from '@/assets/icons/icon-fridge.svg'
import Desk from '@/assets/icons/icon-desk.svg'
import Shower from '@/assets/icons/icon-shower.svg'
import TV from '@/assets/icons/icon-tv.svg'
import Air from '@/assets/icons/icon-air.svg'
import Cabin from '@/assets/icons/icon-cabin.svg'
*/
import Gallery from '@/assets/icons/icon-gallery.svg'
import ArrowDown2 from '@/assets/icons/icon-arrow-down-2.svg'
import Send from '@/assets/icons/icon-send.svg'
import Enter from '@/assets/icons/icon-enter.svg'
import Location from '@/assets/icons/icon-location.svg'
import Share from '@/assets/icons/icon-share.svg'
import Close from '@/assets/icons/icon-close.svg'
import SignOut from '@/assets/icons/icon-sign-out.svg'
import EnvelopeBox from '@/assets/icons/icon-envelope-box.svg'
import PhoneClassic from '@/assets/icons/icon-phone-classic.svg'
import Oclock from '@/assets/icons/icon-oclock.svg'
import Update from '@/assets/icons/icon-update.svg'
import Delete from '@/assets/icons/icon-delete.svg'
import Filter from '@/assets/icons/icon-filter.svg'
import DusWc from '@/assets/icons/icon-dus-ve-wc.svg'
import Etut from '@/assets/icons/icon-etut-odasi.svg'
import Mutfak from '@/assets/icons/icon-mutfak.svg'
import Internet from '@/assets/icons/icon-sinirsiz-internet.svg'
import Dolap from '@/assets/icons/icon-kisisel-dolap.svg'
import Balkon from '@/assets/icons/icon-balkonlu-oda.svg'
import Buzdolap from '@/assets/icons/icon-mini-buzdolabi.svg'
import Klima from '@/assets/icons/icon-klima.svg'
import Sabah from '@/assets/icons/icon-sabah-kahvaltisi.svg'
import Aksam from '@/assets/icons/icon-aksam-yemegi.svg'
import Uydu from '@/assets/icons/icon-tv-ve-uydu-yayini.svg'
import Lig from '@/assets/icons/icon-lig-tv.svg'
import Masa from '@/assets/icons/icon-calisma-masasi.svg'
import Cizim from '@/assets/icons/icon-cizim-odasi.svg'
import Camasir from '@/assets/icons/icon-camasir-ve-utu-odasi.svg'
import Gunluk from '@/assets/icons/icon-gunluk-temizlik.svg'
import Haftalik from '@/assets/icons/icon-haftalik-temizlik.svg'
import Kamera from '@/assets/icons/icon-kamera-sistemi.svg'
import Kafeterya from '@/assets/icons/icon-kafeterya.svg'
import Guvenlik from '@/assets/icons/icon-24-saat-guvenlik.svg'
import Asansor from '@/assets/icons/icon-asansor.svg'
import Hobi from '@/assets/icons/icon-hobi-ve-oyun-odasi.svg'
import Spor from '@/assets/icons/icon-spor-salonu.svg'
import Servis from '@/assets/icons/icon-ucretsiz-servis.svg'
import Telefon from '@/assets/icons/icon-oda-telefonu.svg'
import YorumYok from '@/assets/icons/icon-yorum-yok.svg'
import FiyatSor from '@/assets/icons/icon-fiyat-sor.svg'
import Telefon1 from '@/assets/icons/icon-phone1.svg'
import Web from '@/assets/icons/icon-web.svg'
import Branch from '@/assets/icons/icon-branches.svg'

export default {
  name: 'icon-sprite',
  components: {
    SvgIcon,
    ArrowDown,
    ArrowUp,
    ArrowLongRight,
    ArrowLongLeft,
    Plus,
    Search,
    User,
    Bed,
    Food,
    Phone,
    Wifi,
    ArrowLeft,
    ArrowRight,
    Mail,
    Headphone,
    Facebook,
    Twitter,
    Instagram,
    Linkedin,
    Whatsapp,
    Heart,
    Print,
    Export,
    /*
    RoomTel,
    Library,
    Fridge,
    Desk,
    Shower,
    TV,
    Air,
    Cabin,
    */
    Gallery,
    ArrowDown2,
    Enter,
    Send,
    Location,
    Share,
    Close,
    SignOut,
    EnvelopeBox,
    PhoneClassic,
    Oclock,
    Update,
    Delete,
    Filter,
    DusWc,
    Etut,
    Mutfak,
    Internet,
    Balkon,
    Dolap,
    Buzdolap,
    Sabah,
    Aksam,
    Klima,
    Uydu,
    Lig,
    Masa,
    Cizim,
    Camasir,
    Gunluk,
    Haftalik,
    Kamera,
    Kafeterya,
    Guvenlik,
    Asansor,
    Hobi,
    Spor,
    Servis,
    Telefon,
    YorumYok,
    FiyatSor,
    Telefon1,
    Web,
    Branch
  },
  data () {
    return {
      icons: [
        {
          id: 0,
          name: 'icon-arrow-down'
        },
        {
          id: 1,
          name: 'icon-arrow-up'
        },
        {
          id: 2,
          name: 'icon-arrow-long-right'
        },
        {
          id: 3,
          name: 'icon-arrow-long-left'
        },
        {
          id: 4,
          name: 'icon-plus'
        },
        {
          id: 5,
          name: 'icon-search'
        },
        {
          id: 6,
          name: 'icon-user'
        },
        {
          id: 7,
          name: 'icon-bed'
        },
        {
          id: 8,
          name: 'icon-food'
        },
        {
          id: 9,
          name: 'icon-phone'
        },
        {
          id: 10,
          name: 'icon-wifi'
        },
        {
          id: 11,
          name: 'icon-arrow-right'
        },
        {
          id: 12,
          name: 'icon-arrow-left'
        },
        {
          id: 13,
          name: 'icon-mail'
        },
        {
          id: 14,
          name: 'icon-headphone'
        },
        {
          id: 15,
          name: 'icon-facebook'
        },
        {
          id: 16,
          name: 'icon-twitter'
        },
        {
          id: 17,
          name: 'icon-linkedin'
        },
        {
          id: 18,
          name: 'icon-instagram'
        },
        {
          id: 19,
          name: 'icon-heart'
        },
        {
          id: 20,
          name: 'icon-print'
        },
        {
          id: 21,
          name: 'icon-export'
        },
        {
          id: 22,
          name: 'icon-roomtel'
        },
        {
          id: 23,
          name: 'icon-library'
        },
        {
          id: 24,
          name: 'icon-fridge'
        },
        {
          id: 25,
          name: 'icon-desk'
        },
        {
          id: 26,
          name: 'icon-shower'
        },
        {
          id: 27,
          name: 'icon-tv'
        },
        {
          id: 28,
          name: 'icon-air'
        },
        {
          id: 29,
          name: 'icon-cabin'
        },
        {
          id: 30,
          name: 'icon-gallery'
        },
        {
          id: 31,
          name: 'icon-arrow-down-2'
        },
        {
          id: 32,
          name: 'icon-enter'
        },
        {
          id: 33,
          name: 'icon-send'
        },
        {
          id: 34,
          name: 'icon-location'
        },
        {
          id: 35,
          name: 'icon-share'
        },
        {
          id: 36,
          name: 'icon-close'
        },
        {
          id: 37,
          name: 'icon-sign-out'
        },
        {
          id: 38,
          name: 'icon-envelope-box'
        },
        {
          id: 39,
          name: 'icon-oclock'
        },
        {
          id: 40,
          name: 'icon-phone-classic'
        },
        {
          id: 41,
          name: 'icon-update'
        },
        {
          id: 42,
          name: 'icon-delete'
        },
        {
          id: 43,
          name: 'icon-filter'
        },
        {
          id: 44,
          name: 'icon-klima'
        },
        {
          id: 45,
          name: 'icon-aksam-yemegi'
        },
        {
          id: 46,
          name: 'icon-sabah-kahvaltisi'
        },
        {
          id: 47,
          name: 'icon-mutfak'
        },
        {
          id: 48,
          name: 'icon-kafeterya'
        },
        {
          id: 49,
          name: 'icon-asansor'
        },
        {
          id: 50,
          name: 'icon-hobi-ve-oyun-odasi'
        },
        {
          id: 51,
          name: 'icon-spor-salonu'
        },
        {
          id: 50,
          name: 'icon-balkonlu-oda'
        },
        {
          id: 51,
          name: 'icon-asansor'
        },
        {
          id: 51,
          name: 'icon-yorum-yok'
        },
        {
          id: 52,
          name: 'icon-phone1'
        },
        {
          id: 53,
          name: 'icon-web'
        },
        {
          id: 54,
          name: 'icon-branches'
        }               
      ]
    }
  }
}
</script>

<style scoped>
.icon-sprite {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 288;
  overflow: auto;
  background: #f0f4f9;
}

.icon-sprite__title {
  margin-top: 50px;
  font-size: 55px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 30px;
  color: #546391;
}

.icon-sprite__list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
}

.icon-sprite__item {
  width: 265px;
  text-align: center;
  border: 1px solid #bac2cb;
  margin: 10px;
  border-radius: 9px;
  padding: 20px;
  background: #fff;
}

.icon-sprite__icon {
  font-size: 45px;
  margin-bottom: 10px;
  display: inline-flex;
}

.icon-sprite__name {
  font-size: 20px;
  font-weight: 600;
  background: #e3e9f0;
  border-radius: 6px;
  padding: 3px;
  margin-top: 15px;
}
</style>
